import useSWR from 'swr';

import { getSubscribers } from '../api';
import type { ISubscibersBody } from '../subscribers/types';

export function useSubscribers(propertyId: string) {
  // Tell SWR that the response is the body with a `subscribers` array
  const { data, error, isValidating } = useSWR<ISubscibersBody>(
    () => (propertyId ? ['subscribers', propertyId] : null),
    () => getSubscribers(propertyId),
  );

  return {
    // Extract the actual array (or default to empty)
    subscribers: data?.subscribers ?? [],
    // "Fetched at least once": distinguishes a genuinely empty subscriber list
    // from the fetch still being in flight. isValidating can't serve here (it
    // also flips true on focus revalidation). Consumers deriving state from
    // subscribers (e.g. the stale-invoice banner) gate on this to avoid
    // computing against the transient empty list on first render.
    hasLoaded: data !== undefined,
    isLoading: isValidating,
    isError: !!error,
  };
}
